// extracted by css-extract-rspack-plugin
export default {"container":"MBIgU","narrow_hidden":"DzxJS","narrowHidden":"DzxJS"};